<template>
    <div class="preview-container">
        <div class="close" @click="close">
            <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="media-container animated zoomIn">
            <!--图片形式的预览-->
            <div class="image" v-if="currContentMenu.media === 'images'">
                <div class="curr-image"
                     :style="'background-image: url(\''+projectDetails[currContentMenu.media+'_list'][currMediaIndex].images[currImageIndex].url+'\')'">
                    <div class="image-desc">
                        {{projectDetails[currContentMenu.media+'_list'][currMediaIndex].images[currImageIndex].desc
                        || '暂无描述'}}
                    </div>
                </div>
                <div class="image-list">
                    <swiper ref="imageSwiper" :options="swiperOption">
                        <swiper-slide class="slide-item pointer"
                                      :class="{'image-active':(currImageIndex===index)}"
                                      @click.native="currImageIndex = index"
                                      v-for="(file,index) in projectDetails[currContentMenu.media+'_list'][currMediaIndex].images">
                            <img width="100%" height="100%"
                                 :data-src="file.url"
                                 :class="{'img-selected':file.selected}"
                                 class="swiper-lazy"
                                 >
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </div>
            <!--音频/视频形式的预览-->
            <div class="video" v-if="currContentMenu.media === 'video'">
                <video controls
                       :src="projectDetails[currContentMenu.media+'_list'][currMediaIndex].file.url"
                       width="100%" height="100%"></video>
            </div>
            <div class="audio_bg"
                 :style="'background-image:url('+projectDetails[currContentMenu.media+'_list'][currMediaIndex].cover_pic+')'"
                 v-if="currContentMenu.media === 'audio'"></div>
            <div class="audio-content" v-if="currContentMenu.media === 'audio'">
                <div class="title">
                    {{projectDetails[currContentMenu.media+'_list'][currMediaIndex].title}}
                </div>
                <audio controls
                       :src="projectDetails[currContentMenu.media+'_list'][currMediaIndex].file.url"
                       width="100%" height="100%"></audio>
            </div>
            <!--传承人预览-->
            <div class="successor_container" v-if="currContentMenu.media === 'successor'">
                <div class="successor-info">
                    <div class="successor-avatar" :style="'background-image:url('+projectDetails[currContentMenu.media+'_list'][currMediaIndex].cover_pic+')'">
                    </div>
                    <div class="successor-field">
                        <div class="name">
                            {{projectDetails[currContentMenu.media+'_list'][currMediaIndex].name}}
                        </div>
                        <div class="filed">
                            性别:{{projectDetails[currContentMenu.media+'_list'][currMediaIndex].sex_name}}
                        </div>
                        <div class="filed">
                            出生日期:{{projectDetails[currContentMenu.media+'_list'][currMediaIndex].born_year ||'暂无'}}
                        </div>
                        <div class="filed">
                            民族:汉
                        </div>
                    </div>
                </div>
                <div class="successor-details" v-html="projectDetails[currContentMenu.media+'_list'][currMediaIndex].details">
                </div>
            </div>
            <!--文档预览-->
            <div class="file_container" v-if="currContentMenu.media === 'files'">
                <div class="file-title">{{projectDetails[currContentMenu.media+'_list'][currMediaIndex].title}}</div>
                <div class="file-list">
                    <div class="file-item" v-if="file.file_type == 1" :key="'file_'+index" v-for="(file,index) in projectDetails[currContentMenu.media+'_list'][currMediaIndex].files">
                        <file-ext class="file-icon" :icon="file.extension_name"></file-ext>
                        <div class="file-info">
                            <div class="file-name">{{file.name}}</div>
                            <div class="file-option">
                                <span>大小:{{(file.size/1024/1024).toFixed(2)}}M</span>
                                <span>文件类型:{{file.extension_name}}</span>
                            </div>
                        </div>
                        <div class="download">
                            <a target="_blank" :href="file.url">下载</a>
                        </div>
                    </div>
                    <div class="file-item" v-else>
                        <file-ext class="file-icon" icon="html"></file-ext>
                        <div class="file-info">
                            <div class="file-name">外部链接</div>
                        </div>
                        <div class="download">
                            <a target="_blank" :href="projectDetails[currContentMenu.media+'_list'][currMediaIndex].link_url">进入下载页</a>
                        </div>
                    </div>
                </div>
                <div class="file-details" v-html="projectDetails[currContentMenu.media+'_list'][currMediaIndex].details"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import fileExt from '@/components/file-ext';

    export default {
        name: "preview",
        components:{
            fileExt
        },
        data() {
            return {
                swiperOption: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    loop: false,
                    autoplay: false,
                    lazy:true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                },
                currImageIndex: 0
            }
        },
        methods: {
            close: function () {
                this.$store.commit('setShowPreview', false)
            }
        },
        computed: {
            swiper() {
                return this.$refs.imageSwiper.swiper
            },
            ...mapGetters([
                'showPreview', 'currContentMenu', 'projectDetails', 'currMediaIndex'
            ]),
        },
        mounted: function () {
            this.currImageIndex = 0;
        }
    }
</script>

<style scoped lang="less">
    .preview-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 100;
        padding-top: 80px;
    }

    .close {
        position: absolute;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        top: 4vh;
        right: 16vw;
        background: #fff;
        border-radius: 100px;
        cursor: pointer;
    }

    .media-container {
        margin: 0 auto;
        width: 800px;
        height: 550px;
        background: #fff;
        border-radius: 5px;
        padding: 10px;
        position: relative;
    }

    .image {
        width: 100%;
        height: 100%;

        .img-selected {
            border: 2px solid orange;
        }

        .curr-image {
            width: 100%;
            height: 75%;
            background: center center no-repeat;
            background-size: contain;
            position: relative;
            color: #fff;

            .image-desc {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                max-height: 120px;
                min-height: 20px;
                background: rgba(0, 0, 0, 0.6);
                overflow-y: scroll;
                color: #fff;
                font-size: 13px;
                padding: 10px;
            }
        }

        .image-list {
            padding-top: 10px;
        }
    }

    .pointer {
        cursor: pointer;
        width: 50px;
        height: 120px;
        padding: 2px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .image-active {
        background: orange;
    }

    .video {
        width: 100%;
        height: 100%;

        video {
            outline: none;
        }
    }

    .audio_bg {
        width: 100%;
        height: 100%;
        background: center center no-repeat;
        background-size: cover;
        filter: blur(4px);
    }

    .audio-content {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 10;
        position: absolute;

        .title {
            font-size: 25px;
            text-align: center;
            margin-top: 20%;
            color: #ffffff;
            text-shadow: 4px 4px 4px #888;
        }

        audio {
            outline: none;
            width: 80%;
            margin: 30% auto 0 auto;
            display: block;
        }

    }

    .successor_container{
        padding:20px;
        .successor-info {
            display: flex;
            .successor-avatar {
                width: 35%;
                height: 200px;
                background: no-repeat center center;
                background-size: cover;
                border-radius: 10px;
            }
            .successor-field {
                width: 65%;
                padding-top: 10px;
                padding-left: 30px;
                .name{
                    font-size: 24px;
                    color: #333333;
                }
                .filed{
                    font-size: 14px;
                    color: #999999;
                    margin:10px 0;
                }
            }
        }
        .successor-details{
            margin-top: 50px;
            font-size: 13px;
            color: #666666;
            letter-spacing: 1px;
            line-height: 26px;
            max-height: 230px;
            overflow-y: scroll;
        }
    }
    .file_container{
        padding:20px;
        .file-title{
            font-size: 20px;
        }
        .file-details{
            margin-top: 50px;
            font-size: 13px;
            color: #666666;
            letter-spacing: 1px;
            line-height: 26px;
            max-height: 230px;
            overflow-y: scroll;
        }
        .file-list{
            margin-top: 10px;
            .file-item{
                border-bottom: 1px solid #ccc;
                padding:5px 0;
                display: flex;
                align-items: center;
                .file-icon{
                    width: 35px;
                    height: 35px;
                }
                .file-info{
                    flex-grow: 1;
                    padding-left: 10px;
                    .file-name{
                        font-size: 13px;
                        font-weight: bold;
                    }
                    .file-option{
                        margin-top: 5px;
                        font-size: 12px;
                        span{
                            color: #6d6c6c;
                            margin-right: 20px;
                        }
                    }
                }
                .download,.download a{
                    font-size: 13px;
                    cursor: pointer;
                    color: #0087C8;
                    text-decoration: none;
                }
            }
        }
    }
</style>